/*
  Zenbean order confirmation panel (Sep 2026). Markup: snippets/zb-offer-confirm.liquid.

  Renders from the widget payload only (zb:offer-submit / zb:offer-added detail = calc() in
  assets/zb-offer-v3.js), so it shows exactly the numbers the buy box showed.

  Gift order (Jose, 28 Sep): on 1 Month Supply free shipping comes first (it is the only free
  gift), then book / scoop / mug locked. On Buy 3 and Buy 6: book, scoop, (mug), shipping.

  Upgrade (1 Month only) switches the panel and the widget to Buy 3 in the same format, but does
  NOT touch the cart there. Every way of putting a product in the cart fires Shopify's
  product_added_to_cart, which Meta/TikTok/GA count as another Add to Cart -- tested 28 Sep:
  /cart/add.js, /cart/update.js and even a /cart/<id>:1 permalink all fire it. So the swap waits
  for Continue to Secure Checkout: only shoppers who actually go on to checkout register the extra
  add, and the swap reuses the widget's own cart build (same properties, same gifts).
*/
(function () {
  "use strict";

  var GIFT_ORDER = ["book", "scoop", "mug", "shipping"];

  function boot() {
    var el = document.querySelector("[data-zbcf]");
    if (!el || el.__zbcf) return;
    el.__zbcf = true;
    // Keep the panel out of any transformed/overflow-clipped ancestor in the buy box.
    if (el.parentNode !== document.body) document.body.appendChild(el);

    var panel = el.querySelector("[data-zbcf-panel]");
    var current = null;     // the payload being shown
    var upgraded = false;   // Upgrade tapped since the cart was built
    var lastFocus = null;

    function q(sel) { return el.querySelector(sel); }
    function money(c) { return window.ZBOffer ? window.ZBOffer.money(c) : "$" + Math.round(c / 100); }
    function cap(s) { return s.charAt(0).toUpperCase() + s.slice(1); }
    function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]; }); }
    function img(src) { return src ? '<img src="' + esc(src) + '" alt="" loading="lazy" decoding="async">' : ""; }
    var lock = '<svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" aria-hidden="true"><rect x="5" y="11" width="14" height="9" rx="2"/><path d="M8 11V8a4 4 0 0 1 8 0v3"/></svg>';

    function allGifts() { return (window.ZBOffer && window.ZBOffer.config.gifts) || []; }
    function giftByKey(key) { return allGifts().filter(function (g) { return g.key === key; })[0]; }

    function row(g, on) {
      return '<div class="zbcf-row zbcf-gift' + (on ? "" : " off") + '"><div class="zbcf-thumb">' + img(g.img) + "</div>" +
        '<div class="zbcf-grow zbcf-name">' + esc(g.name) + "</div><s>" + money(g.valueCents) + "</s>" +
        (on ? '<span class="zbcf-free">FREE</span>' : '<span class="zbcf-lockchip">' + lock + "Locked</span>") + "</div>";
    }

    function render(c) {
      current = c;
      var unitWord = c.units === 1 ? c.unit : c.unitsWord;
      q("[data-zbcf-chip]").textContent = "You selected " + c.name + " for " + money(c.price) + " (Save " + money(c.totalSave) + ")";
      q("[data-zbcf-coffee-img]").innerHTML = img(c.formatImg);
      q("[data-zbcf-coffee-name]").textContent = c.units + " " + cap(unitWord) + " of Zenbean";
      q("[data-zbcf-coffee-val]").textContent = c.format + ", value " + money(c.coffeeValue);

      var have = c.gifts.map(function (g) { return g.key; });
      var html;
      if (c.tierIndex === 0) {
        // Shipping first (the only free gift), then everything still locked.
        var free = GIFT_ORDER.filter(function (k) { return have.indexOf(k) > -1; });
        var locked = GIFT_ORDER.filter(function (k) { return have.indexOf(k) < 0; });
        html = free.map(function (k) { return row(giftByKey(k), true); }).join("") +
          locked.map(function (k) { return giftByKey(k) ? row(giftByKey(k), false) : ""; }).join("");
      } else {
        html = GIFT_ORDER.filter(function (k) { return have.indexOf(k) > -1; }).map(function (k) { return row(giftByKey(k), true); }).join("");
      }
      q("[data-zbcf-gifts]").innerHTML = html;

      var up = q("[data-zbcf-upgrade]");
      if (c.tierIndex === 0 && window.ZBOffer) {
        var t = window.ZBOffer.calc(1, c.formatIndex);
        var gained = t.gifts.filter(function (g) { return have.indexOf(g.key) < 0; });
        var shorts = gained.map(function (g) { return g.short; });
        var giftsText = shorts[0] + (shorts.length > 1 ? " + " + shorts.slice(1).map(function (s) { return s.replace(/^the /, ""); }).join(" + ") : "");
        q("[data-zbcf-upgrade-pics]").innerHTML = gained.slice(0, 2).map(function (g) { return '<div class="zbcf-thumb">' + img(g.img) + "</div>"; }).join("");
        q("[data-zbcf-upgrade-title]").textContent = "Save " + money(t.totalSave) + " instead of " + money(c.totalSave);
        q("[data-zbcf-upgrade-text]").textContent = t.name + " for " + money(t.price) + ", " + giftsText + (shorts.length > 1 ? " are" : " is") + " free";
        up.hidden = false;
      } else {
        up.hidden = true;
      }

      q("[data-zbcf-total-value]").textContent = money(c.totalValue);
      q("[data-zbcf-today]").textContent = money(c.price);
      q("[data-zbcf-save]").textContent = "You Save " + money(c.totalSave);
      q("[data-zbcf-bar-today]").textContent = money(c.price);
      q("[data-zbcf-bar-value]").textContent = money(c.totalValue);
      q("[data-zbcf-bar-save]").textContent = "You save " + money(c.totalSave);
    }

    function isOpen() { return !el.hidden; }

    function open(c) {
      upgraded = false;
      render(c);
      if (isOpen()) return;
      lastFocus = document.activeElement;
      el.hidden = false;
      document.documentElement.classList.add("zbcf-lock");
      panel.scrollTop = 0;
      try { history.pushState({ zbcf: true }, ""); } catch (e) {}
      panel.focus({ preventScroll: true });
    }

    function hide() {
      if (!isOpen()) return;
      el.hidden = true;
      document.documentElement.classList.remove("zbcf-lock");
      if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
    }

    // Back to offer / scrim / Escape / the browser back button all land here.
    function close() {
      if (history.state && history.state.zbcf) history.back();
      else hide();
    }
    window.addEventListener("popstate", function () { if (isOpen()) hide(); });
    document.addEventListener("keydown", function (e) { if (e.key === "Escape" && isOpen()) close(); });
    el.querySelectorAll("[data-zbcf-close]").forEach(function (b) { b.addEventListener("click", close); });

    // Keep Tab inside the dialog.
    panel.addEventListener("keydown", function (e) {
      if (e.key !== "Tab") return;
      var f = [].slice.call(panel.querySelectorAll("button:not([disabled]), [href]")).filter(function (n) { return n.offsetParent !== null; });
      if (!f.length) return;
      if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
      else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
    });

    q("[data-zbcf-upgrade-btn]").addEventListener("click", function () {
      if (!current || !window.ZBOffer) return;
      var fmt = current.formatIndex;
      window.ZBOffer.selectTier(1);          // the widget behind shows Buy 3 too
      render(window.ZBOffer.calc(1, fmt));
      upgraded = true;
      panel.scrollTop = 0;
    });

    var checkoutBtn = q("[data-zbcf-checkout]");
    checkoutBtn.addEventListener("click", function () {
      if (checkoutBtn.getAttribute("aria-busy") === "true") return;
      checkoutBtn.setAttribute("aria-busy", "true");
      if (!upgraded) { window.location.href = "/checkout"; return; }
      // Replaces the 1 Month lines with the Buy 3 set (coffee + book + scoop), then checkout.
      window.ZBOffer.buildCart(current)
        .then(function () { upgraded = false; window.location.href = "/checkout"; })
        .catch(function (err) {
          console.error(err);
          checkoutBtn.removeAttribute("aria-busy");
          alert("Sorry, something went wrong updating your order:\n\n" + err.message + "\n\nPlease try again or contact support.");
        });
    });
    // Coming back to this page from checkout (bfcache) must not leave the button stuck.
    window.addEventListener("pageshow", function () { checkoutBtn.removeAttribute("aria-busy"); });

    window.addEventListener("zb:offer-submit", function (e) { render(e.detail); });
    window.addEventListener("zb:offer-added", function (e) { open(e.detail); });

    window.ZBConfirm = { open: open, close: close };
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
})();
